import { z } from 'zod';

export const fieldDefinitionSchema = z.object({
  entityTypeId: z.number().int().positive(),
  fieldKey: z.string().min(2).max(80).regex(/^[a-z][a-zA-Z0-9_]*$/, 'Field key must start with a letter and contain only letters, numbers, and underscores'),
  label: z.string().min(1).max(120),
  fieldType: z.enum(['text', 'email', 'number', 'select', 'multiselect', 'checkbox', 'radio', 'date', 'password', 'textarea', 'file']),
  placeholder: z.string().max(255).optional().nullable(),
  defaultValue: z.any().optional().nullable(),
  options: z.any().optional().nullable(),
  validationRules: z.any().optional().nullable(),
  sortOrder: z.number().int().min(0).optional(),
  isRequired: z.boolean().optional(),
  isActive: z.boolean().optional(),
  conditionalLogic: z.any().optional().nullable(),
  helpText: z.string().max(255).optional().nullable(),
  group: z.string().max(80).optional().nullable(),
});


